import React, { useState } from 'react'
import { Link } from 'react-router-dom'

const ServicesCard = ({ title, slug, image, carStyle }) => {
  const [isLoaded, setIsLoaded] = useState(false)

  return (
    <Link
      to={`/services/${slug}`}
      className="communication-block__card communication-block__card-link"
      style={carStyle}
    >
      <h3 className="communication-block__title">{title}</h3>
      <span className="communication-block__more">
        Подробнее
        <span aria-hidden="true">→</span>
      </span>
      <img
        className={`communication-block__car img-fade-in ${isLoaded ? 'is-loaded' : ''}`}
        src={image}
        alt=""
        aria-hidden="true"
        onLoad={() => setIsLoaded(true)}
      />
    </Link>
  )
}

export default ServicesCard
